var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prism-editor',{staticClass:"my-editor",attrs:{"value":_vm.value,"highlight":_vm.highlighter,"line-numbers":""},on:{"input":v=> _vm.$emit('input', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }